// React
import React, { useState, useEffect, useRef } from "react";

// React Async
import Async from "react-async";

// Components
import { Button, Form, Tabs, Tab, InputGroup, FormControl } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import { useFormFields } from "../libs/hooksLib";
import UserIndexItem from "../components/UserIndexItem";

// Eventify API
import * as EventifyAPI from "../libs/EventifyAPI";

// AWS
import { Auth, API } from "aws-amplify";

// UUID
const uuidv4 = require('uuid/v4');

const UserSideBar = React.forwardRef((props, ref) => {
  const [usersList, setUsersList] = useState([]);
  const [filteredUsersList, setFilteredUsersList] = useState([]);
  const [reloadProtocol, setReloadProtocol] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [focus, setFocus] = useState(false);

  const searchQueryInputRef = React.useRef();

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    fetchAllUsers();
  }

  function fetchAllUsers() {
    if (props.email === null) {
      return;
    }
    EventifyAPI.getAllUsers().then( (users) => {
      setUsersList(users);
      setFilteredUsersList(users);
      setReloadProtocol(uuidv4());
    });
  }

  function renderUsersList(users) {
    return (
      <>
        {users.map( (user, i) => (
          <li key={user.email}>
            <UserIndexItem
              user={user}
              viewUserAction={props.viewUserAction}
            />
          </li>
        ))}
      </>
    );
  }

  var currentSearchQueryLocal = "";

  function searchQueryChanged(query) {
    if (searchQueryInputRef.current === null) {
      return;
    }

    currentSearchQueryLocal = searchQueryInputRef.current.value.trim();
    if (currentSearchQueryLocal === "") {
      setFilteredUsersList(usersList);
      setReloadProtocol(uuidv4());
      return;
    }

    setTimeout( function() {
      const lowerCaseQuery = currentSearchQueryLocal.toLowerCase();
      var newList = [];
      for (var k=0; k<usersList.length; k++) {
        const user = usersList[k];
        const name = user.fullName !== null ? user.fullName : "";
        const email = user.email !== null ? user.email : "";
        if (name.toLowerCase().indexOf(lowerCaseQuery) !== -1 || email.toLowerCase().indexOf(lowerCaseQuery) !== -1) {
          newList.push(user);
        }
      }
      setFilteredUsersList(newList);
      setReloadProtocol(uuidv4());
    }, 0 );
  }

  function focused() {
    setFocus(true);
  }

  function notFocused() {
    setFocus(false);
  }

  function inviteUserPrompt() {
    props.showInviteTeamMemberModal();
  }

  return (
    <div className="user-side-bar">
      <label className="toggle-btn">click me</label>
      <input id="sidebar-toggle" type="checkbox" />

      <div className="content">
        <button
          type="button"
          className="btn btn-primary create-list-button"
          onClick={inviteUserPrompt}
        >
          Invite Team Member
        </button>
        <InputGroup className="mb-3">
          <InputGroup.Prepend>
            <InputGroup.Text id="basic-addon1">Search</InputGroup.Text>
          </InputGroup.Prepend>
          <Form.Control ref={searchQueryInputRef} placeholder="Name or Email" onFocus={focused} onBlur={notFocused} onChange={searchQueryChanged} />
        </InputGroup>
        <ul className="list-index">
          {renderUsersList(filteredUsersList)}
        </ul>
      </div>
    </div>
  );
});

export default UserSideBar;
